import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Star, ArrowRight, Tag } from 'lucide-react';
const shops = [{
  name: 'Serenity Spa',
  cnName: '宁静水疗',
  location: 'Orchard Road',
  rating: 4.9,
  price: '$$$',
  tags: ['Aromatherapy', 'Luxury'],
  image: 'bg-gradient-to-br from-stone-200 to-stone-300'
}, {
  name: 'Golden Hands',
  cnName: '金手指',
  location: 'Chinatown',
  rating: 4.8,
  price: '$$',
  tags: ['TCM', 'Deep Tissue'],
  image: 'bg-gradient-to-br from-amber-100 to-orange-100'
}, {
  name: 'Thai Bliss',
  cnName: '泰享乐',
  location: 'Bugis',
  rating: 4.7,
  price: '$$',
  tags: ['Authentic Thai', 'Herbal'],
  image: 'bg-gradient-to-br from-green-100 to-emerald-100'
}, {
  name: 'Harmony Wellness',
  cnName: '和谐养生',
  location: 'Tanjong Pagar',
  rating: 4.8,
  price: '$$$',
  tags: ['Full Body', 'Detox'],
  image: 'bg-gradient-to-br from-blue-100 to-indigo-100'
}];
export function FeaturedShops() {
  return <section id="featured" className="py-24 bg-cream/50" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-4" data-id="element-11">
          <div data-id="element-12">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-forest mb-2" data-id="element-13">
              Top Recommended{' '}
              <span className="text-gold font-light" data-id="element-14">精选推荐</span>
            </h2>
            <p className="text-stone" data-id="element-15">
              Curated selection of Singapore's highest-rated wellness centers.
            </p>
          </div>
          <a href="#" className="text-gold-dark hover:text-forest font-medium flex items-center gap-2 transition-colors" data-id="element-16">
            View All Shops <ArrowRight size={16} data-id="element-17" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-18">
          {shops.map((shop, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group" data-id="element-19">
              {/* Image Placeholder */}
              <div className={`h-48 w-full ${shop.image} relative`} data-id="element-20">
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-md flex items-center gap-1 text-xs font-bold text-forest shadow-sm" data-id="element-21">
                  <Star size={12} className="fill-gold text-gold" data-id="element-22" />
                  {shop.rating}
                </div>
              </div>

              <div className="p-5" data-id="element-23">
                <div className="flex justify-between items-start mb-2" data-id="element-24">
                  <div data-id="element-25">
                    <h3 className="font-serif font-bold text-lg text-forest group-hover:text-gold transition-colors" data-id="element-26">
                      {shop.name}
                    </h3>
                    <p className="text-sm text-stone/60" data-id="element-27">{shop.cnName}</p>
                  </div>
                  <span className="text-sm font-medium text-stone/40" data-id="element-28">
                    {shop.price}
                  </span>
                </div>

                <div className="flex items-center text-stone/70 text-sm mb-4" data-id="element-29">
                  <MapPin size={14} className="mr-1" data-id="element-30" />
                  {shop.location}
                </div>

                <div className="flex flex-wrap gap-2 mb-6" data-id="element-31">
                  {shop.tags.map((tag, i) => <span key={i} className="px-2 py-1 bg-cream rounded-md text-xs text-stone/70 font-medium" data-id="element-32">
                      {tag}
                    </span>)}
                </div>

                <button className="w-full py-2 border border-forest/20 text-forest rounded-lg hover:bg-forest hover:text-white transition-colors duration-300 text-sm font-medium" data-id="element-33">
                  View Details
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}